import React from "react";
import PropTypes from "prop-types";

import { Invisible, Tool } from "@frontend/morpheus";

import AppErrorHandler from "../components/AppErrorHandler";

const CreateFeedForm = React.lazy(() =>
  import(/* webpackChunkName: "CreateFeedForm" */ "./components/CreateFeedForm")
);
const TestErrno = React.lazy(() =>
  import(/* webpackChunkName: "TestErrno" */ "./components/TestErrno")
);
const TestPopups = React.lazy(() =>
  import(/* webpackChunkName: "TestPopups" */ "./components/TestPopups")
);
const RegressTool = React.lazy(() =>
  import(/* webpackChunkName: "RegressTool" */ "./components/RegressTool")
);
const LocaleCheckout = React.lazy(() =>
  import(/* webpackChunkName: "RegressTool" */ "./components/LocaleCheckout")
);

const switchTheme = (theme) => {
  document.body.dataset.theme = theme;
  localStorage.setItem("theme", theme);
};

const Features = ({ handleServiceUnavailable }) =>
  window.postMessage && (
    <>
      <AppErrorHandler slot="Locale switching">
        <Invisible
          name="Locale switching"
          on={() => (
            <React.Suspense fallback="">
              <LocaleCheckout />
            </React.Suspense>
          )}
          off={() => null}
        />
      </AppErrorHandler>
      <AppErrorHandler slot="Theme switcher">
        <Tool
          name="Включить старую тему"
          callback={() => {
            switchTheme("old-theme");
          }}
        />
        <Tool
          name="Включить новую светлую тему"
          callback={() => {
            switchTheme("default-theme");
          }}
        />
      </AppErrorHandler>
      <AppErrorHandler slot="service unavailable">
        <Tool
          name="Включить Сервис недоступен"
          callback={() => {
            handleServiceUnavailable();
          }}
        />
      </AppErrorHandler>
      <AppErrorHandler slot="test errno">
        <Invisible
          name="Test errno"
          on={() => (
            <React.Suspense fallback="">
              <TestErrno />
            </React.Suspense>
          )}
          off={() => null}
        />
      </AppErrorHandler>
      <AppErrorHandler slot="Test popups">
        <Invisible
          name="Test popups"
          on={() => (
            <React.Suspense fallback="">
              <TestPopups />
            </React.Suspense>
          )}
          off={() => null}
        />
      </AppErrorHandler>
      <AppErrorHandler slot="Regress tool">
        <Invisible
          name="Regress tool"
          on={() => (
            <React.Suspense fallback="">
              <RegressTool />
            </React.Suspense>
          )}
          off={() => null}
        />
      </AppErrorHandler>
      <AppErrorHandler slot="test feed">
        <Invisible
          name="Test feed"
          on={() => (
            <React.Suspense fallback="">
              <CreateFeedForm />
            </React.Suspense>
          )}
          off={() => null}
        />
      </AppErrorHandler>
    </>
  );

Features.propTypes = {
  handleServiceUnavailable: PropTypes.func,
};

export default Features;
